import { defineStore } from "pinia";
export interface IRootObject {
  pollingResult: string;
  shouldCloseDialog: boolean;
}
export const useN5pollingStore = defineStore("N5polling", {
  state: (): IRootObject => {
    return {
      pollingResult: "",
      shouldCloseDialog: false,
    };
  },
  getters: {},
  actions: {
    // setName(data: string) {
    //   console.log("data11", data);
    //   this.name = data;
    // },
    setPollingResult(data: string) {
      console.log("data11", data);
      this.pollingResult = data;
    },
    setPollingDialog(data: boolean) {
      console.log("data11", data);
      this.shouldCloseDialog = data;
    },
    resetDialogState() {
      this.shouldCloseDialog = false;
    },
  },
});
